(ns dashboard.views.analysis.analysis-bank.events
  (:require [dashboard.ui :as ui]
            [dashboard.views.analysis.analysis-bank.config :as config]
            [dashboard.views.analysis.structured-analysis.record-structured-analysis-modal :as record-modal]
            [dashboard.views.analysis.structured-analysis.view-structured-analysis-modal :as view-structured-analysis]
            [re-frame.core :as rf]))

(defn create-initial-structured-analysis [parent-analysis]
  {:construct ""
   :parent-id (:construct-id parent-analysis)
   :states [[(random-uuid) "Not Yet Evaluated"]
            [(random-uuid) "True"]
            [(random-uuid) "False"]
            [(random-uuid) "Out of scope"]
            [(random-uuid) "Needs More Information"]]
   :categories (or (:categories parent-analysis) [])
   :relates-to [""]
   :excludes [""]
   :comment ""
   :state-dependencies {}})

(rf/reg-event-fx
  ::show-record-structured-analysis-modal
  (fn [_ [_ parent-analysis]]
    {:fx [[:dispatch [::record-modal/update-data
                      (create-initial-structured-analysis parent-analysis)]]
          [:dispatch [::ui/push-modal
                      {:component #'record-modal/record-structured-analysis-modal
                       :on-close #(rf/dispatch [::record-modal/clear-data])
                       :ctx {:mode :create
                             :on-view-analysis (fn [construct-id version-id]
                                                 (rf/dispatch [::view-structured-analysis/show-modal construct-id version-id]))}
                       :content-props {:style {:min-width "75vw" :max-height "90vh" :padding 0}}}]]]}))

(rf/reg-event-db
  ::toggle-include-initialized-analyses
  (fn [db _]
    (let [value (get-in db [config/view-id :include-initialized-analyses] true)]
      (assoc-in db [config/view-id :include-initialized-analyses] (not value)))))
